import { render } from "./NewListingsSoldPropertiesChart.vue?vue&type=template&id=4aa09ec4&ts=true"
import script from "./NewListingsSoldPropertiesChart.vue?vue&type=script&lang=ts"
export * from "./NewListingsSoldPropertiesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__